module.exports = __webpack_public_path__ + "media/puzzle4_6.31fff03c.mp3";